import HomeRequest from '@/shared/infrastructure/home/Request'

const actions = {
  async fetchTop9Category() {
  const data = await HomeRequest.top9CategoryRequest()
  return data
  },
  async fetchFeaturedFreelancer() {
    const data = await HomeRequest.featuredFreelancerRequest()
    return data
  },
  async fetchFeturedCategoryFreelancer(actions, {category_id, currentPage}) {
    const data = await HomeRequest.featuredCategoryFreelancerRequest(category_id,currentPage)
    return data
  },
  async fetchAllFreelancers(actions , pageNumber) {
    const data = await HomeRequest.allFreelancerRequest(pageNumber)
    return data
  },
}

export default actions